var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC372D",
    d: "M9.922 2.573a4.07 4.07 0 0 1 4.156 0l4.844 2.868C20.208 6.203 21 7.611 21 9.134v5.736c0 1.523-.792 2.931-2.078 3.693l-4.844 2.868a4.07 4.07 0 0 1-4.156 0l-4.844-2.868C3.792 17.8 3 16.393 3 14.87V9.134c0-1.523.792-2.931 2.078-3.693z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.001,
    cy: 17,
    r: 1,
    fill: "#fff",
    transform: "rotate(-180 12 17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.063,
    d: "M12 13.998v-7"
  })));
};
export default SvgAlert;